// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-canvas[data-v-3b97f2d3]{width:100%;min-height:100vh;display:flex;justify-content:center;align-items:center;background-color:#f8f7f4}.app-canvas .actions[data-v-3b97f2d3]{padding:30px 0}.app-canvas .actions button[data-v-3b97f2d3]{padding:10px;cursor:pointer}.app-canvas__wrapper[data-v-3b97f2d3]{width:100%;max-width:600px}.app-canvas__wrapper .form[data-v-3b97f2d3]{background-color:#fff;border-radius:8px;box-shadow:0 0 10px rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
